var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "material-page" },
    [
      _vm._m(0),
      _c(
        "el-card",
        { staticClass: "filter-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "toolbar" },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  on: { change: _vm.handleTabChange },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c("el-radio-button", { attrs: { label: "sales" } }, [
                    _vm._v("销售订单"),
                  ]),
                  _c("el-radio-button", { attrs: { label: "purchase" } }, [
                    _vm._v("采购订单"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        staticClass: "keyword",
                        attrs: {
                          clearable: "",
                          placeholder:
                            _vm.activeTab === "sales"
                              ? "订单号 / 工地 / 客户"
                              : "采购单号 / 工地 / 供应商",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.keywords,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "keywords",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.keywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", placeholder: "全部状态" },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        _vm._l(_vm.currentStatuses, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: { click: _vm.openCreateSales },
                        },
                        [_vm._v("代下单")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "metrics" }, [
        _c("div", [
          _c("span", [
            _vm._v(_vm._s(_vm.activeTab === "sales" ? "销售订单" : "采购订单")),
          ]),
          _c("strong", [_vm._v(_vm._s(_vm.tableData.total))]),
          _c("small", [_vm._v("TOTAL")]),
        ]),
        _c("div", { staticClass: "warning" }, [
          _c("span", [_vm._v("当前页待处理")]),
          _c("strong", [_vm._v(_vm._s(_vm.pendingCount))]),
          _c("small", [_vm._v("PENDING")]),
        ]),
        _c("div", { staticClass: "success" }, [
          _c("span", [_vm._v("当前页已完成")]),
          _c("strong", [_vm._v(_vm._s(_vm.completedCount))]),
          _c("small", [_vm._v("COMPLETED")]),
        ]),
        _c("div", { staticClass: "amount" }, [
          _c("span", [_vm._v("当前页金额")]),
          _c("strong", [_vm._v("¥" + _vm._s(_vm.money(_vm.pageAmount)))]),
          _c("small", [_vm._v("AMOUNT")]),
        ]),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card",
          attrs: { shadow: "never", "body-style": { padding: "0 20px 20px" } },
        },
        [
          _c(
            "div",
            { staticClass: "title-row" },
            [
              _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.activeTab === "sales"
                        ? "销售订单台账"
                        : "采购履约台账"
                    )
                  ),
                ]),
                _c("span", [_vm._v("点击订单查看商品、价格快照及履约信息")]),
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", icon: "el-icon-refresh" },
                  on: { click: _vm.getList },
                },
                [_vm._v("刷新")]
              ),
            ],
            1
          ),
          _vm.activeTab === "sales"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    data: _vm.tableData.data,
                    size: "mini",
                    "highlight-current-row": "",
                  },
                  on: { "row-click": _vm.openSalesDetail },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "销售单号 / 工地", "min-width": "210" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("div", { staticClass: "two-line" }, [
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.sales(row).salesOrderNo)),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      row.project && row.project.projectName
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1508744638
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "客户", "min-width": "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(_vm._s(row.customer && row.customer.name)),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2577249842
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "主材明细", width: "90", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(_vm._s((row.items || []).length) + " 项"),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2091881342
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "应付 / 已付",
                      "min-width": "150",
                      align: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c("div", { staticClass: "money" }, [
                                _c("strong", [
                                  _vm._v(
                                    "¥" +
                                      _vm._s(
                                        _vm.money(_vm.sales(row).payableAmount)
                                      )
                                  ),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    "¥" +
                                      _vm._s(
                                        _vm.money(_vm.sales(row).paidAmount)
                                      )
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2376682537
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "支付", width: "95", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.payTag[_vm.sales(row).payStatus],
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.payText(_vm.sales(row).payStatus)
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1848882550
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "履约", width: "100", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                _vm._s(
                                  _vm.fulfilmentText(
                                    _vm.sales(row).fulfilmentStatus
                                  )
                                )
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1697720638
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "95", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: _vm.salesTag[
                                      _vm.sales(row).orderStatus
                                    ],
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.salesStatusText(
                                        _vm.sales(row).orderStatus
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2461651746
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "230",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.openSalesDetail(row)
                                    },
                                  },
                                },
                                [_vm._v("查看")]
                              ),
                              _vm.sales(row).orderStatus === "pending"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.confirmSales(
                                            row,
                                            "approve"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("审核通过")]
                                  )
                                : _vm._e(),
                              _vm.sales(row).orderStatus === "effective" &&
                              _vm.sales(row).payStatus !== "paid"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.confirmSales(row, "pay")
                                        },
                                      },
                                    },
                                    [_vm._v("确认收款")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2797469437
                    ),
                  }),
                ],
                1
              )
            : _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    data: _vm.tableData.data,
                    size: "mini",
                    "highlight-current-row": "",
                  },
                  on: { "row-click": _vm.openPurchaseDetail },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "采购单号 / 工地", "min-width": "210" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", { staticClass: "two-line" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.purchase(row).purchaseOrderNo)
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(row.project && row.project.projectName)
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "供应商", "min-width": "150" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [_vm._v(_vm._s(_vm.supplierName(row)))]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "明细", width: "80", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(_vm._s((row.items || []).length) + " 项"),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "应付 / 已付",
                      "min-width": "150",
                      align: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("div", { staticClass: "money" }, [
                              _c("strong", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.money(_vm.purchase(row).payableAmount)
                                    )
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.money(_vm.purchase(row).paidAmount)
                                    )
                                ),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "到货日期", width: "120", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.purchase(row).expectedArrivalDate || "--"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "履约", width: "100", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.fulfilmentText(
                                  _vm.purchase(row).fulfilmentStatus
                                )
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "95", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type: _vm.purchaseTag[
                                    _vm.purchase(row).status
                                  ],
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.purchaseStatusText(
                                      _vm.purchase(row).status
                                    )
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "220",
                      fixed: "right",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.openPurchaseDetail(row)
                                  },
                                },
                              },
                              [_vm._v("查看")]
                            ),
                            _vm._l(
                              _vm.purchaseActions(_vm.purchase(row)),
                              function (action) {
                                return _c(
                                  "el-button",
                                  {
                                    key: action.value,
                                    attrs: { type: "text", size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.confirmPurchase(
                                          row,
                                          action.value
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(action.label))]
                                )
                              }
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.detail
        ? _c(
            "el-drawer",
            {
              attrs: {
                visible: _vm.drawerVisible,
                size: "610px",
                "custom-class": "material-order-drawer",
                "with-header": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.drawerVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "drawer-head" },
                [
                  _c("div", [
                    _c("span", [_vm._v(_vm._s(_vm.detailNo))]),
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.detail.project && _vm.detail.project.projectName
                        )
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.detailType === "sales"
                            ? _vm.detail.customer && _vm.detail.customer.name
                            : _vm.supplierName(_vm.detail)
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type:
                          _vm.detailType === "sales"
                            ? _vm.salesTag[_vm.sales(_vm.detail).orderStatus]
                            : _vm.purchaseTag[_vm.purchase(_vm.detail).status],
                      },
                    },
                    [_vm._v(_vm._s(_vm.detailStatus))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "drawer-body" },
                [
                  _c("div", { staticClass: "detail-grid" }, [
                    _c("div", [
                      _c("span", [_vm._v("商品金额")]),
                      _c("strong", [
                        _vm._v(
                          "¥" + _vm._s(_vm.money(_vm.detailOrder.goodsAmount))
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c("span", [_vm._v("应付金额")]),
                      _c("strong", [
                        _vm._v(
                          "¥" + _vm._s(_vm.money(_vm.detailOrder.payableAmount))
                        ),
                      ]),
                    ]),
                    _c("div", [
                      _c("span", [_vm._v("支付状态")]),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.payText(_vm.detailOrder.payStatus))),
                      ]),
                    ]),
                    _c("div", [
                      _c("span", [_vm._v("履约状态")]),
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.fulfilmentText(_vm.detailOrder.fulfilmentStatus)
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "item-title" }, [
                    _vm._v("商品与价格快照"),
                  ]),
                  _vm._l(_vm.detail.items || [], function (line) {
                    return _c(
                      "div",
                      { key: line.id, staticClass: "detail-line" },
                      [
                        _c("div", [
                          _c("strong", [_vm._v(_vm._s(line.itemName))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(line.skuText || line.unit) +
                                " · " +
                                _vm._s(line.quantity) +
                                " " +
                                _vm._s(line.unit)
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("strong", [
                            _vm._v("¥" + _vm._s(_vm.money(line.lineAmount))),
                          ]),
                          _c("span", [
                            _vm._v(
                              "单价 ¥" +
                                _vm._s(
                                  _vm.money(
                                    line.salePrice || line.purchasePrice
                                  )
                                )
                            ),
                          ]),
                        ]),
                      ]
                    )
                  }),
                  _vm.detailType === "purchase"
                    ? _c("div", { staticClass: "delivery" }, [
                        _c("span", [_vm._v("收货信息")]),
                        _c("p", [
                          _vm._v(_vm._s(_vm.detailOrder.deliveryAddress)),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(_vm.detailOrder.contactName) +
                              " · " +
                              _vm._s(_vm.detailOrder.contactMobile)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "drawer-actions" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.drawerVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                  _vm.detailType === "sales"
                    ? [
                        _vm.sales(_vm.detail).orderStatus === "pending"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmSales(
                                      _vm.detail,
                                      "approve"
                                    )
                                  },
                                },
                              },
                              [_vm._v("审核通过")]
                            )
                          : _vm._e(),
                        _vm.sales(_vm.detail).orderStatus === "effective" &&
                        _vm.sales(_vm.detail).payStatus !== "paid"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function ($event) {
                                    return _vm.confirmSales(_vm.detail, "pay")
                                  },
                                },
                              },
                              [_vm._v("确认收款")]
                            )
                          : _vm._e(),
                      ]
                    : _vm._l(
                        _vm.purchaseActions(_vm.purchase(_vm.detail)),
                        function (action) {
                          return _c(
                            "el-button",
                            {
                              key: action.value,
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmPurchase(
                                    _vm.detail,
                                    action.value
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(action.label))]
                          )
                        }
                      ),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "后台代下单",
            visible: _vm.createVisible,
            width: "520px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createVisible = $event
            },
            open: _vm.loadCreateOptions,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "88px", size: "small" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "工地" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "选择工地" },
                      model: {
                        value: _vm.createForm.projectId,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "projectId", $$v)
                        },
                        expression: "createForm.projectId",
                      },
                    },
                    _vm._l(_vm.projectOptions, function (item) {
                      return _c("el-option", {
                        key: item.project.id,
                        attrs: {
                          label: item.project.projectName,
                          value: item.project.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "选择商品" },
                      on: { change: _vm.onCreateProductChange },
                      model: {
                        value: _vm.createForm.productId,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "productId", $$v)
                        },
                        expression: "createForm.productId",
                      },
                    },
                    _vm._l(_vm.productOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "数量" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 1, precision: 0 },
                    model: {
                      value: _vm.createForm.quantity,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "quantity", $$v)
                      },
                      expression: "createForm.quantity",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "单价" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, precision: 2 },
                    model: {
                      value: _vm.createForm.salePrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "salePrice", $$v)
                      },
                      expression: "createForm.salePrice",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 2 },
                    model: {
                      value: _vm.createForm.remark,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.createForm,
                          "remark",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "createForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.createVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.creating },
                  on: { click: _vm.submitCreateSales },
                },
                [_vm._v("创建草稿")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hero" }, [
      _c("div", [
        _c("span", [_vm._v("MATERIAL SALES & PROCUREMENT")]),
        _c("h2", [_vm._v("主材销售与采购")]),
        _c("p", [
          _vm._v("审核销售订单、确认收款并跟踪供应采购、签收与安装履约。"),
        ]),
      ]),
      _c("div", { staticClass: "hero-badges" }, [
        _c("b", [_vm._v("销售审核")]),
        _c("b", [_vm._v("采购履约")]),
        _c("b", [_vm._v("金额快照")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }